'use client'

import Section from '../molecules/section';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import TrailerModal from './trailerModal';
import { useContext } from 'react';
import { ModalContext } from '../../contexts/modal-provider';
import { useLocale } from 'next-intl';
import Link from 'next/link';

const SectionContent = ({ t, subTitleKey, descriptionKey }: { t: Function; subTitleKey: string; descriptionKey: string }) => (
    <div className='w-full flex text-base flex-col justify-start px-4 lg:px-0'>
        <h4 className="font-bold text-left leading-none text-2xl font-sora text-white">
            {t(subTitleKey)}
        </h4>
        <p className="text-white text-left text-base font-normal leading-6 mt-2 mb-6 font-quicksand gap-0">
            {t(descriptionKey)}
        </p>
    </div>
);


const PlotBuilder = () => {
    const t = useTranslations('PlotBuilder');
    const router = useRouter()
    const { openModal } = useContext(ModalContext);
    const currentLocale = useLocale();
    return (
        <>
            <Section
                id="PlotBuilder"
                backgroundImage="/images/plot-builder3.avif"
                className="relative flex flex-col min-h-screen items-center justify-center bg-auto"
            >
                {/* Dark overlay */}
                <div className="absolute inset-0 bg-black opacity-50"></div>

                {/* Top gradient */}
                <div className="absolute inset-x-0 top-0 h-64 bg-gradient-to-b from-black to-transparent"></div>

                {/* Bottom gradient */}
                <div className="absolute inset-x-0 bottom-0 h-64 bg-gradient-to-t from-black to-transparent"></div>

                <div className="relative flex flex-col items-center text-center pt-12 pb-2">
                    <div className='flex flex-col-reverse lg:flex-row space-y-8 lg:space-y-0  justify-center items-center mt-40'>
                        <div className='sm:w-full md:w-full lg:w-[calc(40%-2.5rem)] xl:w-[calc(60%-2.5rem)] 2xl:w-[calc(50%-2.5rem)] flex flex-col items-center justify-center space-y-4'>
                            <div className='flex justify-center  relative cursor-pointer' onClick={() => openModal({ type: 'VIDEO_MODAL', videoSrc: 'https://www.youtube.com/watch?v=lbAUuMH31AA' })}>
                                <Image
                                    src="/images/plot-builder.avif"
                                    width={600}
                                    height={250}
                                    className="rounded-3xl mb-4 px-4 lg:px-0 sm:h-[25rem] md:h-[25rem] lg:h-[30rem] xl:h-[30rem] 2xl:h-[26rem] bg-center"
                                    sizes="100%"
                                    alt="plot-builder"
                                />
                            </div>
                        </div>
                        <div className='sm:w-full md:w-full lg:w-[calc(60%-2.0rem)] xl:w-[calc(60%-2.5rem)] 2xl:w-[calc(60%-2.5rem)] flex flex-col items-center justify-center space-y-4 my-4 pr-4'>
                            <div className='w-full flex justify-start px-4 lg:px-0'>
                                <h2 className="text-4xl font-bold leading-none lg:text-5xl font-sora text-white">
                                    {t('title')}
                                </h2>
                            </div>
                            <SectionContent t={t} subTitleKey='sections.build.subTitle' descriptionKey='sections.build.description' />
                            <SectionContent t={t} subTitleKey='sections.customize.subTitle' descriptionKey='sections.customize.description' />
                            <SectionContent t={t} subTitleKey='sections.decorate.subTitle' descriptionKey='sections.decorate.description' />
                        </div>
                    </div>
                    <Link
                        href={`/${currentLocale}/map`}
                        className="mr-3 sm:my-8 md:my-8 lg:mt-24 flex items-center justify-center rounded-full border border-[#F17E0E] bg-[#F38F2E] px-6 py-3 text-center text-xs md:text-sm font-medium text-white sm:px-10 sm:py-4 lg:px-19 lg:py-3"
                    >
                        {t('view-btn')}
                        <span className="ml-2">→</span>
                    </Link>
                </div>
            </Section>
            <TrailerModal />
        </>
    );
};

export default PlotBuilder;